import { Link } from "react-router-dom";
import { categoryShowcase } from "@/mocks/home";

export default function CategoryShowcase() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            探索风格
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            日系、韩系、欧美、美式——四大国际风格，找到属于你的时尚语言
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {categoryShowcase.map((cat) => (
            <Link
              key={cat.id}
              to={cat.link}
              className="group relative rounded-lg overflow-hidden cursor-pointer h-[300px] md:h-[380px]"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-background-50/80">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}